import React from "react";

export default function Footer() {
  function Logo({ logo }) {
    return (
      <img
        src={logo}
        alt=""
        className="rounded-lg select-none mx-3"
        width={35}
        height={35}
      />
    );
  }
  return (
    <div className="select-custom h-[35px] flex justify-between max-w-[900px] mx-auto mt-[50px]">
      <div className="flex">
        <a href="https://t.me/Unipay_Channel" target="_blank" rel="noopener noreferrer" className="text-[#A9A9A9] hover:text-white mx-4">Telegram</a>
        <a href="https://discord.gg/v7gwuMmfXU" target="_blank" rel="noopener noreferrer" className="text-[#A9A9A9] hover:text-white mx-4">Discord</a>
        <a href="https://twitter.com/UnipayHQ" target="_blank" rel="noopener noreferrer" className="text-[#A9A9A9] hover:text-white mx-4">Twitter</a>
        <a href="https://docs.unipay.fi" target="_blank" rel="noopener noreferrer" className="text-[#A9A9A9] hover:text-white mx-4">Docs</a>
        <a href="https://github.com/unipayfi" target="_blank" rel="noopener noreferrer" className="text-[#A9A9A9] hover:text-white mx-4">GitHub</a>
      </div>

      <p className="h-[25px] font-semibold text-[#A9A9A9] text-md text-center my-auto">
        © 2025 Unipay. All rights reserved.
      </p>
    </div>
  );
}
